import React from "react";
import { Button } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

function Account({
  ondeleteAccount,
  loading,
  actionText,
  accountName,
  accountNumber,
  bankName,
}) {
  return (
    <div>
      <p>{accountName}</p>
      <p>
        {accountNumber}&nbsp;{bankName}
      </p>
      {accountNumber && (
        <Button
          type="primary"
          icon={<DeleteOutlined />}
          onClick={ondeleteAccount}
          loading={loading}
        >
          {actionText || "Delete"}
        </Button>
      )}
    </div>
  );
}

export default Account;
